<script lang="ts">
  import { onDestroy, onMount } from "svelte"
  import React from "react"
  import ReactDOM from "react-dom/client"
  import Loading from "website_script/components/Loading.svelte"
  import { colors } from "component_library/styles/theme"

  export let componentName: string

  const e = React.createElement
  let container: HTMLDivElement | null = null
  let root: ReactDOM.Root | null = null
  let Component: React.ComponentType<any> | null = null
  let isLoading = true

  // We can't import components using a variable like `import(componentPath)`
  // because Vite needs to see the actual file path ahead of time to include it in the build.
  //
  // This map lets us load components dynamically without confusing Vite.
  const componentMapper: Record<string, () => Promise<any>> = {
    PricingInsights: () => import("pricing_insights/PricingInsights"),
    // Add more components when needed
  }

  async function loadComponent() {
    try {
      const importFn = componentMapper[componentName]
      if (!importFn) {
        throw new Error(`Unknown component name: ${componentName}`)
      }
      const module = await importFn()
      Component = module.default
    } catch (err) {
      console.warn("Failed to load React component:", { err })
    } finally {
      isLoading = false
    }
  }

  // Render the React component
  function renderReactComponent() {
    if (!Component || !container) return

    const { children, _componentName, class: _, ...props } = $$props
    try {
      if (!root) {
        root = ReactDOM.createRoot(container)
      }
      root.render(e(Component, props, children))
    } catch (err) {
      console.warn("react-adapter failed to mount or update.", { err })
    }
  }

  onMount(async () => {
    await loadComponent()
    renderReactComponent()
  })

  onDestroy(() => {
    try {
      root?.unmount()
    } catch (err) {
      console.warn("react-adapter failed to unmount.", { err })
    }
  })
</script>

{#if isLoading}
  <div class="auws-loading-container">
    <Loading color={colors.variant_600} />
  </div>
{/if}

{#if Component}
  <div bind:this={container} class={$$props.class} />
{/if}

<style>
  .auws-loading-container {
    width: 100%;
    display: flex;
    min-height: 100px;
    justify-content: center;
    align-items: center;
  }
</style>
